import _ReactGA from "react-ga4";
const ReactGA = _ReactGA.default;

export const trackGaEvent = (action, category, options = {}) => {
  ReactGA.event({
    action,
    category,
    ...options,
  });
};
